import { renameKeys } from '@/utils'
import type { PadInfo, FlatPadInfo } from '@/features/Pad'

export const flattenPadInfo = (values: PadInfo): FlatPadInfo => {
  const { financial_info, personal_info } = values
  const data: FlatPadInfo = renameKeys({
    street1: 'bank_street1',
    street2: 'bank_street2',
    city: 'bank_city',
    state: 'bank_state',
    country: 'bank_country',
    zip: 'bank_zip'
  })({
    ...financial_info
  })
  return { ...data, ...personal_info }
}
